import React from 'react';
import OfferingInfo from "../models/OfferingInfo"


class OfferingDropdownGenerator {

    generateSectionComponents(offeringData: OfferingInfo): React.JSX.Element[] {


      return offeringData.textSections.map((offering, index) => (
        <div key={`${offeringData.id}-${index}`} className="offering-section">
          <h4>{offering.sectionTitle}</h4>
          <div className='offering-section-content'>
            {offering.sectionText}
          </div>
        </div>
      ));
  }
}

export default OfferingDropdownGenerator